const REACT_APP_API = process.env.REACT_APP_API_URL || "";

// Référentiels (grammaire, langues, pays, sources, domaines, collèges...)
// chargés une fois ici, au Dashboard (première page de l'app après login),
// et mis en cache dans localStorage. creation_fiche (DynamicSelect) les
// relit directement sans jamais les re-fetcher lui-même.
//
// Si une requête échoue (res.ok === false, ex. session pas encore prête,
// 401/500 transitoire), on laisse le cache existant tel quel plutôt que d'y
// écrire la réponse d'erreur — c'est ce qui provoquait auparavant un select
// vide (localStorage contenait la chaîne "undefined", imparsable par
// DynamicSelect).
async function cacheFromApi(storageKey, path) {
  const res = await fetch(`${REACT_APP_API}${path}`, { credentials: "include" });

  if (!res.ok) {
    console.error(`Erreur chargement ${storageKey} (${path}) : HTTP ${res.status}`);
    return;
  }

  const data = await res.json();
  localStorage.setItem(storageKey, JSON.stringify(data.member));
}

export async function loadReferenceData() {
  await Promise.all([
    cacheFromApi('gramm_cat', '/api/gramm_cat_gcats'),
    cacheFromApi('langage_lgas', '/api/langage_lgas'),
    cacheFromApi('pays_pays', '/api/pays_pays'),
    cacheFromApi('langue_lgus', '/api/langue_lgus'),
    cacheFromApi('source_sces', '/api/source_sces'),
    cacheFromApi('domaine_doms', '/api/domaine_doms'),
    cacheFromApi('commission_coms', '/api/commission_coms'),
  ]);
}
